module.exports = __webpack_public_path__ + "static/INGMeWeb-Bold-a1d59afa1efe789d1e6544a198c8cc66.woff";